import React from 'react';
import styles from "./TransactionTypeBadge.module.scss";

// type - 
// primary
// secondary
// green
// orange

const TransactionTypeBadge = ({ children, type, className, }) => {
    return (
        <div
            className={`${styles.badge} ${className || ""}`}
            data-type={type}
        >
            <p>{children}</p>
        </div>
    )
}

export default TransactionTypeBadge;